import React, { SyntheticEvent, useState } from 'react';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import Tab from '@mui/material/Tab';
import SipRegister from './Register/SipRegister';
import SipClientManagement from './_components/SipClientManagement';
import SipClientReasonsManagement from './Reason/SipClientReasonsManagement';

const SipPage = () => {
  const [value, setValue] = useState('1');
  const handleChange = (event: SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <TabContext value={value}>
      <TabList onChange={handleChange}>
        <Tab label="Ramal" value="1" />
        <Tab label="Registro" value="2" />
        <Tab label="Justificativas" value="3" />
      </TabList>
      <TabPanel value="1">
        <SipClientManagement />
      </TabPanel>
      <TabPanel value="2">
        <SipRegister />
      </TabPanel>
      <TabPanel value="3">
        <SipClientReasonsManagement />
      </TabPanel>
    </TabContext>
  );
};

export default SipPage;
